/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pkl_Toast_Update_PxkInputs */

const vi_pkl_toast_update_pxk = /** @type {(inputs: Pkl_Toast_Update_PxkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đã lưu thay đổi phiếu xuất vật tư`)
};

/**

* @param {Pkl_Toast_Update_PxkInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const pkl_toast_update_pxk = /** @type {((inputs?: Pkl_Toast_Update_PxkInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pkl_Toast_Update_PxkInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_pkl_toast_update_pxk(inputs)
});